import { Card, Button } from 'react-bootstrap';
import '../style.css';


export default function GuanteoCard({ image, description, videoLink }) {

  return (
    <Card className="guanteo-card">
      <Card.Img variant="top" src={image} alt="Guanteo escena" />
      <Card.Body>
        <Card.Text>{description}</Card.Text>
        <Button className='botonyoutube' variant="danger" href={videoLink} target="_blank">
          ▶ YouTube
        </Button>
      </Card.Body>
    </Card>
  );
}
